import Vue from 'vue'
import vuetify from './plugins/vuetify';
import router from './router'
import App from './App.vue'

// Set up axios for accessing our api
import axios from 'axios';
// If we're running on the localhost, then:
if (window.location.hostname === "localhost") {
  // Use localhost for API calls.
  axios.defaults.baseURL = "http://localhost:54381/";
} else {
  // else use the production API endpoint.
  axios.defaults.baseURL = "https://api.marketscout.xbyte.com/";
}

// SignalR hub
import ScannerHub from './scanner-hub';
Vue.use(ScannerHub);

// Vue Notifications
import Notifications from 'vue-notification'
Vue.use(Notifications)

// Moment used to format dates nicely.
import moment from 'moment';

Vue.config.productionTip = false

// TODO:  Move filters to their own js file
// Formats the supplied number value to a nice Currency output.
// Defaults to 2 numbers after the decimal place.
Vue.filter('toCurrency', function (value, decimalPlaces = 2) {
  if (typeof value !== "number") {
      return value;
  }

  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
  });
  return formatter.format(value).replace("$", "$ ");
});


// Formats the supplied date value to a nice string result like "3 days ago".
Vue.filter('toFriendlyDate', function (value, returnForInvalidDate = '(none)') {
  // If the date is not valid, then:
  if (!value)
    // Return whatever was requested when we don't have a valid date.
    return returnForInvalidDate;

  // Else we have a valid date, so return moment's nicely formatted text for it.
  return moment(value).from(new Date());
});

// Formats the supplied date value to just the date - "03/17/20".
Vue.filter('toDateOnly', function (value, returnForInvalidDate = '(none)') {
  // If the date is not valid, then:
  if (!value)
    // Return whatever was requested when we don't have a valid date.
    return returnForInvalidDate;

  // Else we have a valid date, so return moment's just-the-date format.
  return moment(value).format("MM/DD/YY");
});


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
